<template>
  <div>
    <nav class="navbar navbar-light navbar-edit fixed-top navbar__content-detail">
      <ul class="navbar-nav justify-content-end">
        <div class="container">
          <div class="row">
            <li id="save-point" class="nav-item mr-4 ml-auto">
              <div v-show="isSavedProject" id="div-save-text" class="nav-link">글이 저장되었습니다</div>
              <div v-show="!isSavedProject" id="div-fail-text" class="nav-link">글이 저장되지 않았습니다</div>
            </li>
            <li class="nav-item mr-2">
              <input
                id="save"
                type="button"
                :disabled="isUpdating"
                class="btn btn-primary pull-right cow-button-save"
                value="저장하기"
                @click="updateProject()"
              />
            </li>
            <li class="nav-item mr-4">
              <a class="btn btn-secondary" :href="previewLink" target="_blank">미리보기</a>
            </li>
          </div>
        </div>
      </ul>
    </nav>
    <transition name="fade">
      <div v-if="showFadeInOutSuccess" class="alert alert-success alert-text-success-inline">
        <strong>수고하셨습니다!</strong> 잘 저장되었습니다!
      </div>
    </transition>
    <div class="margin-top-100"></div>

    <update-error-modal :message-html="updateErrorModalMessageHtml"></update-error-modal>
  </div>
</template>

<script>
import { EventBus } from '../event-bus.js';
import UpdateErrorModal from './UpdateErrorModal';

export default {
  name: 'OnairDescriptionNavigation',
  components: {
    UpdateErrorModal,
  },
  props: ['projectId', 'previewLink'],
  data() {
    return {
      isSavedProject: true,
      isUpdating: false,
      showFadeInOutSuccess: false,
      updateErrorModalMessageHtml:
        '<p>글을 저장하는 도중 오류가 발생하였습니다.<br> 다시 한번 저장한 후에도 같은 문제가 계속된다면 관리자에게 문의해 주세요.</p>',
    };
  },
  created() {
    EventBus.$on('setIsSavedProject', this.setIsSavedProject);
    this.addBeforeUnloadEventListener();
  },
  methods: {
    route(routeName) {
      let url = '';
      if (routeName === 'onair.update') {
        url = location.protocol + '//' + location.hostname + '/api/onair/' + this.projectId;
      }
      return url;
    },
    updateProject() {
      this.setIsUpdating(true); //start
      const vm = this;
      const onairDescription = this.$store.state.onairDescriptionEditor.onairDescriptions;

      this.$http
        .put(this.route('onair.update'), {
          onair_description: onairDescription,
        })
        .then(function (response) {
          vm.setIsSavedProject(true);
          vm.fadeInOutUpdateSuccessText();
        })
        .catch(function (error) {
          vm.setIsSavedProject(false);
          vm.alertUpdateFailText(error.response);
        })
        .then(function (response) {
          vm.setIsUpdating(false); //done
        });
    },

    setIsUpdating(isUpdating) {
      this.isUpdating = isUpdating;
    },

    convertFromObjectToArray(object) {
      return Object.values(object);
    },

    fadeInOutUpdateSuccessText() {
      this.showFadeInOutSuccess = true;
      let vm = this;
      setTimeout(function () {
        vm.showFadeInOutSuccess = false;
      }, 1000);
    },

    alertUpdateFailText(response) {
      if (response.status === 401) {
        this.updateErrorModalMessageHtml =
          '<p>장시간 저장하지 않아 세션이 만료되었습니다.<br>작성하신 내용을 저장하시려면?<br>새 탭에서 로그인하신 후, 현재 탭에서 [저장하기] 버튼을 다시 클릭해 주세요.</p>';
      } else {
        try {
          this.updateErrorModalMessageHtml = response.data.error.message;
        } catch (e) {
          this.updateErrorModalMessageHtml =
            '<p>글을 저장하는 도중 오류가 발생하였습니다.<br> 다시 한번 저장한 후에도 같은 문제가 계속된다면 관리자에게 문의해 주세요.</p>';
        }
      }
      $('#modal-fail').modal();
    },
    setIsSavedProject(isSavedProject) {
      this.isSavedProject = isSavedProject;
    },
    addBeforeUnloadEventListener() {
      window.addEventListener('beforeunload', this.beforeUnloadEventHandler);
    },

    beforeUnloadEventHandler(e) {
      if (!this.isSavedProject) {
        e.returnValue = 'Do you really want to close?';
      }
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.alert-text-success-inline {
  position: fixed;
  top: 61px;
  text-align: center;
  width: 100%;
  z-index: 1;
}
</style>
